<div class="content">
  <div class="component-header">
    <h3 class="pcl-tagline highlight-line">Careers</h3>
    <h1>Job Postings</h1>
  </div>
  <div>
    <div class="flex-container column column-gap-24">
      <form [formGroup]="postingSearchCriteriaForm" class="flex-container column column-gap-24">
        <div>
          <mat-form-field subscriptSizing="dynamic" class="mat-form-field full-width">
            <mat-label>Search by keyword</mat-label>
            <input
              matInput
              [formControl]="searchControl"
              [placeholder]="searchHint"
              (focus)="onSearchFocus()"
              maxlength="100" />
            @if (postingSearchCriteriaForm.get(FormControlNames.PartialJobTitle)!.value) {
              <button matSuffix mat-icon-button aria-label="Clear" (click)="searchControl.setValue('')">
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        </div>
        <mat-divider class="margin-vertical-16"></mat-divider>
        <div class="flex-container wrap space-between">
          <mat-form-field subscriptSizing="dynamic" class="mat-form-field">
            <mat-label>Company</mat-label>
            <mat-select [formControlName]="FormControlNames.CompanyName">
              <mat-option>All companies</mat-option>
              @for (company of companies; track company) {
                <mat-option [value]="company.name">{{ company.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic" class="mat-form-field">
            <mat-label>Country</mat-label>
            <mat-select [formControlName]="FormControlNames.IsoCountry">
              <mat-option>All countries</mat-option>
              @for (country of countries; track country) {
                <mat-option [value]="country.name">{{ PCL_OPERATING_COUNTRIES[country.name] }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic" class="mat-form-field">
            <mat-label>Province / State</mat-label>
            <mat-select [formControlName]="FormControlNames.IsoRegionalSubdivisions" multiple>
              @for (subdivision of subdivisions; track subdivision) {
                <mat-option [value]="subdivision.name">{{ COUNTRY_SUBDIVISIONS[subdivision.name] }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic" class="mat-form-field">
            <mat-label>City</mat-label>
            <mat-select [formControlName]="FormControlNames.Cities" multiple>
              @for (city of cities; track city) {
                <mat-option [value]="city.name">{{ city.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <button mat-flat-button class="mat-flat-button secondary margin-top-16" type="reset">
          <mat-icon>clear</mat-icon>Clear Filters
        </button>
      </form>
      <mat-divider class="margin-vertical-16"></mat-divider>
      @if (postings && postings.length > 0) {
        <div class="flex-container wrap space-between center">
          <span class="pcl-headline-2">Search Results</span>
          <div class="spacer"></div>
          <mat-form-field subscriptSizing="dynamic" class="mat-form-field-no-grow">
            <mat-label>Sort By</mat-label>
            <mat-select [(value)]="sortBy" (selectionChange)="sortPostings($event.value)">
              @for (option of sortOptions; track option) {
                <mat-option [value]="option.value">{{ option.viewValue }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>
    <div class="postings-container">
      @if (postings && postings.length > 0) {
        @for (posting of postings; track posting) {
          <app-posting [posting]="posting"></app-posting>
        }
        <mat-paginator
          [length]="totalPostings"
          [pageSize]="postingSearchCriteriaForm.get(FormControlNames.PageSize)!.value"
          [pageIndex]="postingSearchCriteriaForm.get(FormControlNames.PageIndex)!.value"
          [pageSizeOptions]="pageSizeOptions"
          [showFirstLastButtons]="true"
          (page)="onPageChange($event)"></mat-paginator>
      }
      @if (postingsLoaded && (!postings || postings.length === 0)) {
        <p>No job postings match your criteria.</p>
      }
    </div>
  </div>
</div>
